import { useCallback, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import MobileNavigation from './MobileNavigation'
import CopilotWidget from '../copilot/CopilotWidget'
import { getMerchant } from '../../services/merchant'
import { useMerchantStore } from '../../stores/merchantStore'
import AnnouncementShell from '../announcements/AnnouncementShell'
import MerchantAgreementGate from '../legal/MerchantAgreementGate'

function MobileAnnouncementGuard({ active, close }: { active: boolean; close: () => void }) {
  useEffect(() => { if (active) close() }, [active, close])
  return null
}

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 1023px)').matches)
  const [mobileOpen, setMobileOpen] = useState(false)
  const closeMobileNavigation = useCallback(() => setMobileOpen(false), [])
  const setMerchant = useMerchantStore(state => state.setMerchant)
  useEffect(() => {
    const media = window.matchMedia('(max-width: 1023px)')
    const sync = () => { setMobile(media.matches); setMobileOpen(false) }
    media.addEventListener('change', sync)
    return () => media.removeEventListener('change', sync)
  }, [])
  useEffect(() => {
    getMerchant().then(res => setMerchant(res.data)).catch(() => {})
  }, [setMerchant])
  return (
    <>
      <div className="dashboard-layout min-h-screen bg-background text-foreground">
        {!mobile && <div id="desktop-navigation" className={`fixed inset-y-0 left-0 z-30 ${collapsed ? 'w-20' : 'w-64'}`}><Sidebar collapsed={collapsed} onNavigate={() => {}} /></div>}
        <div className={`min-w-0 ${!mobile ? (collapsed ? 'lg:pl-20' : 'lg:pl-64') : ''}`}>
          <AnnouncementShell>
            {(announcementHeader, urgentAnnouncementActive, onAgreementDialogsClosed) => (
              <>
                <MobileAnnouncementGuard active={urgentAnnouncementActive} close={closeMobileNavigation} />
                <Header collapsed={collapsed} setCollapsed={setCollapsed} announcementHeader={announcementHeader} mobileNavigationTrigger={mobile ? (
                  <MobileNavigation open={mobileOpen} onOpenChange={setMobileOpen} />
                ) : undefined} />
                <main aria-label="商戶頁面內容" className="dashboard-content min-w-0 p-4 lg:p-6">
                  <MerchantAgreementGate urgentAnnouncementActive={urgentAnnouncementActive} onAgreementDialogsClosed={onAgreementDialogsClosed} onDialogOpen={closeMobileNavigation}>
                    <Outlet />
                  </MerchantAgreementGate>
                </main>
              </>
            )}
          </AnnouncementShell>
        </div>
        <CopilotWidget />
      </div>
    </>
  )
}
